var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6617 2.46046C20.7455 2.28387 20.6686 2.07139 20.4892 1.99078C17.6453 0.713732 14.4885 0 11.1623 0C7.83599 0 4.67918 0.713732 1.83541 1.99078C1.65585 2.07139 1.57899 2.28387 1.66281 2.46046L10.8416 21.7984C10.9691 22.0672 11.3554 22.0672 11.4829 21.7984L20.6617 2.46046Z",
    fill: "#C21A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9127 5.70522L11.5597 10.6637C11.0563 11.7243 9.97903 12.4014 8.79513 12.4014H7.91211L11.0898 5.70522H7.91608L8.20405 5.10024C8.6717 4.11763 9.67057 3.49054 10.768 3.49054H17.7615L17.4736 4.09551C17.0059 5.07812 16.007 5.70522 14.9096 5.70522H13.9127Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.9164697f656c240a0b94883128ce94c7.svg";
export { ForwardRef as ReactComponent };